import { render, staticRenderFns } from "./LocationKYBFiles.vue?vue&type=template&id=ef5fa1ea&"
import script from "./LocationKYBFiles.vue?vue&type=script&lang=js&"
export * from "./LocationKYBFiles.vue?vue&type=script&lang=js&"
import style0 from "./LocationKYBFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports